export class Amount {
  readonly #value: number;

  private constructor(value: number) {
    this.#value = value;
  }

  static of(value: number | Amount): Amount {
    if (value instanceof Amount) {
      return value;
    }
    return new Amount(value);
  }

  get human(): string {
    return Intl.NumberFormat('en-US', { currency: 'USD', style: 'currency' }).format(this.#value);
  }
}
